import { render, staticRenderFns } from "./InfoRequestCta.vue?vue&type=template&id=0b94aa5e"
import script from "./InfoRequestCta?vue&type=script&lang=ts&external"
export * from "./InfoRequestCta?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports